import React from 'react';
import { FaEye, FaIntercom, FaMailBulk, FaRadiationAlt } from 'react-icons/fa';
import CopyToClipboard from '../../../../../core/components/CopyToClipboard';
import { urlWebsite } from '../../../../../../../config';
import { useSocket } from '../../../../../../../hooks/Socket';
import { useModal } from '../../../../../../../hooks/Modal';
import Review from '../../../modules/Review';
import api from '../../../../../../../services/api';
import { useLoading } from 'src/hooks/LoadingHook';
import { useToast } from 'src/hooks/Toast';
import { convertToXLSX } from 'src/utils/download';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ListComplete({ configuration }): JSX.Element {

  const { addModal } = useModal();
  const { addLoading, removeLoading } = useLoading();
  const { addToast } = useToast();

  const openReview = async () => {
    addLoading({ title: 'Carregando', key: 'loading' })

    try {
      const avaliations = await api.get(`/cientific-avaliations`, { params: { limitItems: 10000, where: { project_id: configuration?.url } } });


      const avaliators = await api.get(`/cientific-avaliators`, { params: { limitItems: 10000 } });


      const list = [["email", "name"]]


      avaliations?.data?.rows?.map(avaliation => {

        const avaliator = avaliators?.data?.rows?.find(i => i?._id?.toString() === avaliation?.avaliator_id_response?._id?.toString())

        const index = list?.findIndex((i) => i?.[1] === avaliator?.email?.trim()?.toLowerCase());

        if (index < 0) {
          if (avaliator?.email?.indexOf("@") >= 0) {
            list.push([avaliator?.name, avaliator?.email?.toLowerCase()?.trim()])
          }

        }

      })

      convertToXLSX(list);
      removeLoading('loading');
      addToast({ title: 'Relatório gerado com sucesso', type: 'success' })

    }
    catch (err) {

      console.log(err);
      removeLoading('loading');
      addToast({ title: err?.response?.data?.error || err?.response?.data?.message || 'Erro ao gerar relatório', type: 'error' })

    }

  }


  const moduleCreate = (): JSX.Element => {

    return <div onClick={() => openReview()} className="searchButton">
      <FaMailBulk className="hover" style={{ cursor: 'pointer' }} /></div>;
  }



  return moduleCreate();
}
